import { Component, Input } from '@angular/core';

@Component({
  selector: 'info-pair',
  templateUrl: './info-pair.component.html',
  styleUrls: ['./info-pair.component.scss'],
  standalone: false,
})
export class InfoPairComponent {
  @Input() label: string = '';
  @Input() icon?: string; // Material icon name
  @Input() tooltip: string = '';
  @Input() enableEllipsis: boolean = false;
  @Input() customClass: string = '';
}
